import getOr from "lodash/fp/getOr";

import { apiContact } from "../../utils/api";
import { getCurrentUser } from "../../utils/firebase";
import { getPrice } from "../../utils/utils";
import { validateNeedHelp } from "../../utils/validate";

const $ = window.$;

export const needHelpPopupSetup = () => {
  $(".needhelp-form").on("submit", function (e) {
    e.preventDefault();
    const apiTime = Date.now();
    window.apiTime = apiTime;
    if (validateNeedHelp()) {
      submitDataNeedHelp(apiTime);
    }
  });

  $('#needhelp-modal').on('hidden.bs.modal', function (e) {
    $(".needhelp-form .message").hide();
    $(".needhelp-form input, .needhelp-form textarea").removeClass("is-invalid");
  });

  $('#needhelp-modal').on('shown.bs.modal', function () {
    const user = getCurrentUser();
    const displayName = getOr("", "displayName")(user);
    const email = getOr("", "email")(user);
    $('#needhelp-modal .name input').val(displayName);
    $('#needhelp-modal .email input').val(email);

    if (!displayName) {
      $(".needhelp-form .name input").focus();
    } else {
      if (!email) {
        $(".needhelp-form .email input").focus();
      } else {
        $(".needhelp-form .feedback textarea").focus();
      }
    }
  })
}

export const submitDataNeedHelp = (apiTime) => {
  apiContact({
    meta_data: {
      name: $('.needhelp-form .name input').val(),
      email: $('.needhelp-form .email input').val(),
      url: window.location.href,
      message: $('.needhelp-form .feedback textarea').val(),
      export_country: $('.export-country select').val(),
      destination_country: $('.destination-country select').val(),
      product: $('.product input.form-control').attr("data") || $('.product input.form-control').val(),
      order_value: getPrice($('.order-value input').val()),
      currency: $('.order-value select').val()
    }
  }, function (data) {
    $(".needhelp-form .message").show();
    setTimeout(function () {
      $(".needhelp-form .message").hide();
    }, 3000);
    resetFormNeedHelp();
  }, function (error) {
    $(".needhelp-form .message").show();
    resetFormNeedHelp();
  }, apiTime);
}

export const resetFormNeedHelp = () => {
  $('.needhelp-form .name input').val("").trigger("change");
  $('.needhelp-form .email input').val("").trigger("change");
  $('.needhelp-form .feedback textarea').val("").trigger("change");
}

export const showNeedHelpForm = (e) => {
  if (e && typeof e.preventDefault === "function") {
    e.preventDefault();
  }
  $('#needhelp-modal').modal('show');
  $(".needhelp-form .name input").focus();
}

export const setUpFooter = () => {
  needHelpPopupSetup();
}

window.onscroll = function () { scrollFunction() };

function scrollFunction() {
  if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
    $(".scroll-to-top").addClass("pop_class");
  } else {
    $(".scroll-to-top").removeClass("pop_class");
  }
}

$(".scroll-to-top").on("click", function (e) {
  e.preventDefault();
  $(window).scrollTop(0);
})

export const navActive = () => {
  switch (window.location.pathname) {
    case "/covid19.html/":
    case "/covid19.html":
      $(".nav-covid19").addClass("active");
      break;
    case "/glossary.html/":
    case "/glossary.html":
      $(".nav-glossary").addClass("active");
      break;
    case "/datasource.html/":
    case "/datasource.html":
      $(".nav-datasource").addClass("active");
      break;
    case "/blogs/":
    case "/blogs":
      $(".nav-blogs").addClass("active");
      break;
    case "/faq/":
    case "/faq":
      $(".nav-faq").addClass("active");
      break;
    case "/duty-tax-calculation/":
    case "/duty-tax-calculation":
      $(".user-info-box .duty-tax-calculation").addClass("active");
      break;
    case "/classification/":
    case "/classification":
      $(".user-info-box .classification").addClass("active");
      break;
    case "/trade-advisory/":
    case "/trade-advisory":
      $(".user-info-box .trade-advisory").addClass("active");
      break;
    case "/your-plan/":
    case "/your-plan":
      $(".user-info-box .your-plan").addClass("active");
      break;
    case "/profile-management/":
    case "/profile-management":
      $(".user-info-box .profile-management").addClass("active");
      break;

    default:
      break;
  }
}

navActive();